export const BOOKING_SET_PHONE = 'BOOKING_SET_PHONE';
export const BOOKING_SET_TIME_SPECIAL = 'BOOKING_SET_TIME_SPECIAL';
export const BOOKING_SET_ID_SUCCESS = 'BOOKING_SET_ID_SUCCESS';